import { FC } from 'react';
import { CloseCircleFilled, FileOutlined, ReloadOutlined } from '@ant-design/icons';
import Button from 'components/new-ui/base/button/Button';
import { ErrorGenerateDocument, HyperLinkDiv, LoadingDocuments } from './styles';
import useGeneratedDocument from './useGeneratedDocument';

type GeneratedDocument = ReturnType<typeof useGeneratedDocument>;

interface DocumentRowProps {
    label: string;
    defaultFileName: string;
    state: GeneratedDocument;
    onRefresh: () => void;
}

const DocumentRow: FC<DocumentRowProps> = ({ label, defaultFileName, state, onRefresh }) => {
    const { file, url, loading } = state;

    if (loading) return <LoadingDocuments />;

    if (!file) {
        return (
            <ErrorGenerateDocument>
                <CloseCircleFilled /> Error generating {label}
                <Button size="small" type="link" icon={<ReloadOutlined />} onClick={onRefresh}>
                    Refresh
                </Button>
            </ErrorGenerateDocument>
        );
    }

    const fullName = `${file.fileName ?? defaultFileName}${file.type ?? '.pdf'}`;

    return (
        <HyperLinkDiv onClick={() => url && window.open(url)}>
            <FileOutlined /> {fullName}
        </HyperLinkDiv>
    );
};

export default DocumentRow;
